import * as React from 'react';

const Pages = (props:any) => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path d="M3 21h6V11H3v10zm8 0h10V11H11v10zM3 3v6h18V3H3z" fill="#FFF" fillRule="nonzero" />
        </g>
    </svg>
);

export default Pages;

